import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Design Tips",
    date: "15 May, 2025",
    admin: "Admin",
    heading: "5 Creative Door Design Ideas For Modern Homes",
    important: {
      content: "Investing in creative door designs can transform the look and feel of your home, adding character and personality to every room. Discover the possibilities and unlock the potential of your living spaces with these innovative ideas.",
      intro: "Design Specialist"
    },
    paragraph: {
      para1: "Elevate the style and functionality of your modern home with these five creative door design ideas. Doors play a crucial role in defining the aesthetic appeal and functionality of a home, and these innovative designs will surely make a statement.",
      para2: "From sleek and minimalist designs to bold and unconventional styles, there's something for every taste and preference. Explore these ideas to find inspiration for your next door renovation project.",
      para3: "Each design concept is accompanied by insightful commentary and tips for implementation, ensuring that you can bring your vision to life with ease. Let's explore these door design ideas and elevate your home to new heights of style and sophistication.",
      para4: "Visualize these door design ideas through our gallery and imagine how they can enhance the beauty and functionality of your modern home. With the right door design, you can create a welcoming and stylish ambiance that reflects your unique sense of style."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Door", "Design", "Style"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Benjamin Alexander",
        date: "04 Feb, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Isabella Grace",
            date: "05 Feb, 2025",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Samuel James",
        date: "05 Feb, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Maintenance Guide",
    date: "05 May, 2025",
    admin: "Admin",
    heading: "The Ultimate Guide to Maintaining Windows",
    important: {
      content: "Regular window maintenance not only enhances the lifespan of your windows but also ensures better energy efficiency and aesthetics. Discover practical tips to keep your windows in top shape year-round.",
      intro: "Home Improvement Expert"
    },
    paragraph: {
      para1: "Windows are one of the most important components of your home’s structure and comfort. This guide will walk you through essential maintenance practices that preserve the quality and functionality of your windows.",
      para2: "From cleaning glass panes to checking for air leaks and replacing worn-out seals, consistent care can prevent expensive repairs down the road. These proactive measures will help you avoid common window problems.",
      para3: "Our step-by-step recommendations include seasonal checks, proper cleaning tools, and quick fixes for issues like stuck sashes or condensation buildup. With just a little effort, your windows can look and perform like new.",
      para4: "Visual examples in our gallery will inspire you to take immediate action and appreciate the value of well-maintained windows. Let this guide be your go-to resource for preserving window quality year after year."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Windows", "Maintenance", "Comfort"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Ava Mitchell",
        date: "13 Feb, 2025",
        content: "This guide was super helpful! I never realized how much difference regular maintenance can make.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Liam Carter",
            date: "14 Feb, 2025",
            content: "Absolutely agree! Just replaced the seals on my old windows—huge improvement."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Sophia Bennett",
        date: "15 Feb, 2025",
        content: "Thanks for the tips. I’m planning to follow this guide for my spring home maintenance."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Energy Efficiency",
    date: "29 April, 2025",
    admin: "Admin",
    heading: "How Solar Panels Impact Window Design",
    important: {
      content: "As solar technology evolves, homeowners and architects are rethinking how windows interact with rooftop solar panels. This post explores how solar panels influence window placement, size, and energy efficiency.",
      intro: "Green Building Specialist"
    },
    paragraph: {
      para1: "Integrating solar panels into your home isn't just about harnessing the sun—it's also about optimizing the entire building envelope, including windows. The relationship between solar panels and windows can significantly affect your home's energy performance.",
      para2: "South-facing windows may need strategic shading to prevent overheating, while roof-mounted solar panels could affect how much natural light enters the home. Designers must balance daylighting with solar efficiency.",
      para3: "New technologies like photovoltaic windows or smart glass open up exciting possibilities for homeowners looking to merge function and sustainability. These innovations help reduce energy bills while maintaining a modern aesthetic.",
      para4: "Whether you're retrofitting a home or starting from scratch, understanding how solar panels and windows work together is key to achieving a harmonious, eco-friendly design. Explore these insights and more in our comprehensive breakdown."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Solar", "Windows", "Design"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Nathan Reynolds",
        date: "21 Feb, 2025",
        content: "This article gave me a lot to think about before I install solar panels. Great insights!",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Ella Watson",
            date: "22 Feb, 2025",
            content: "Totally agree. It’s something most people overlook when planning solar setups."
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Lucas Hayes",
        date: "23 Feb, 2025",
        content: "Loved the part about photovoltaic windows—had no idea that tech even existed!"
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Security Solutions",
    date: "18 April, 2025",
    admin: "Admin",
    heading: "Enhancing Home Security with Modern Door Locks",
    important: {
      content: "Smart locks and advanced door systems are revolutionizing home security. In this post, we explore how modern locking technology improves safety, convenience, and peace of mind for homeowners.",
      intro: "Home Security Expert"
    },
    paragraph: {
      para1: "Traditional locks are being replaced by a new generation of smart door systems. From keyless entry to biometric authentication, homeowners now have access to more secure and customizable locking solutions.",
      para2: "Modern door locks offer features like remote access, temporary digital keys for guests, and integration with home automation systems. These innovations not only enhance security but also make managing access easier than ever.",
      para3: "Smart locks also provide real-time alerts and access logs, helping you monitor who enters and exits your home. With robust encryption and tamper-proof designs, today’s locks are built to prevent break-ins.",
      para4: "Whether you’re upgrading your existing lock or outfitting a new smart home, understanding your options in modern locking systems is essential for building a secure environment. Discover the latest technologies and choose the right solution for your home."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Security", "Door", "Design"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Jessica Lee",
        date: "13 Mar, 2025",
        content: "This was super helpful—I’ve been on the fence about smart locks, but this cleared things up!",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Mike Thompson",
            date: "14 Mar, 2025",
            content: "Same here! I especially like the idea of access logs and remote control."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Ava Brooks",
        date: "15 Mar, 2025",
        content: "Smart locks seem like a must-have these days—great breakdown of the features."
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Customer Stories",
    date: "05 April, 2025",
    admin: "Admin",
    heading: "How Our Products Improved Home Comfort and Style",
    important: {
      content: "From sleek window treatments to energy-efficient doors, discover how our products have transformed everyday living spaces into stylish, comfortable havens. Real stories, real upgrades.",
      intro: "Interior Design Consultant"
    },
    paragraph: {
      para1: "Designing a home is about more than just looks—it’s about creating a space that feels just right. Our latest collection of home products blends functionality with aesthetic appeal to bring new life to any room.",
      para2: "Homeowners have seen noticeable improvements in insulation, natural lighting, and overall ambience. From noise-reducing windows to stylish custom doors, every product is crafted with both comfort and beauty in mind.",
      para3: "One popular upgrade has been our energy-efficient sliding doors, which not only add elegance but also help lower utility bills. Paired with smart window designs, these upgrades have become customer favorites.",
      para4: "We’re proud to showcase real stories from clients who have experienced the transformation firsthand. Read on to see how our solutions brought warmth, light, and a fresh new look to their homes."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Comfort", "Style", "Products"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Emily Carson",
        date: "26 Mar, 2025",
        content: "Loved seeing the before-and-after shots—your products really make a difference!",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Ben Martin",
            date: "27 Mar, 2025",
            content: "Agreed! Those sliding doors are on my wishlist now."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Sophia James",
        date: "28 Mar, 2025",
        content: "We installed your energy-efficient windows last month and noticed a big change—great product!"
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Design Tips",
    date: "26 March, 2025",
    admin: "Admin",
    heading: "Choosing the Right Door Style for Your Home",
    important: {
      content: "Your front door says a lot about your home. From classic wooden styles to sleek modern options, this guide helps you pick a door that complements your architecture and lifestyle.",
      intro: "Architectural Style Advisor"
    },
    paragraph: {
      para1: "Choosing the perfect door style isn't just about aesthetics—it’s about matching function, personality, and architectural harmony. The right door sets the tone for your entire home.",
      para2: "Traditional homes often look best with paneled wooden doors or elegant glass inserts, while modern homes benefit from minimalist styles with clean lines and metal finishes.",
      para3: "Color, hardware, and material play key roles too. Fiberglass doors offer durability and energy efficiency, while steel provides top-tier security. Wood remains a timeless choice for its warmth and character.",
      para4: "Whether you’re replacing an old entryway or designing a custom build, our expert tips will help you choose a door that’s stylish, functional, and welcoming."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Door", "Style", "Design"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Daniel Moore",
        date: "6 Apr, 2025",
        content: "This helped me finally decide on a door style for our remodel—thanks for the guidance!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Lily Zhang",
            date: "6 Apr, 2025",
            content: "Same here! Loved the breakdown by architectural type."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Owen Patel",
        date: "7 Apr, 2025",
        content: "Really informative. Didn't realize how much a door can influence curb appeal."
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Design Tips",
    date: "15 March, 2025",
    admin: "Admin",
    heading: "Modern Door Designs: 5 Inspiring Ideas for Contemporary Homes",
    important: {
      content: "Looking for fresh, modern door designs for your home? Check out these five innovative ideas that perfectly complement contemporary architecture and bring a stylish, bold statement to your entryway.",
      intro: "Design Specialist"
    },
    paragraph: {
      para1: "Contemporary homes demand doors that are not only functional but also make a design statement. Here are five modern door styles that can elevate the exterior of your home while providing durability and security.",
      para2: "1. **Glass Panel Doors** – Sleek and minimalist, glass panel doors create a stunning visual impact. Their transparent nature allows natural light to flood your entryway, while still maintaining privacy with frosted or etched glass options.",
      para3: "2. **Pivot Doors** – These doors rotate on a central pivot rather than traditional hinges, offering a bold, modern look. Perfect for large entryways, pivot doors are often made from steel or wood, creating a striking focal point.",
      para4: "3. **Metal & Wood Combos** – Combining materials like steel and wood creates a sophisticated contrast. A metal frame with wooden panels is ideal for those seeking a door that’s both sturdy and stylish.",
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Door", "Design", "Style"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Mia Roberts",
        date: "19 Apr, 2025",
        content: "Love these ideas! I’m really drawn to the glass panel doors for our entryway.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Lucas Gomez",
            date: "20 Apr, 2025",
            content: "Glass doors are stunning, but don’t forget about privacy. Frosted glass is a great option!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Emma Clark",
        date: "20 Apr, 2025",
        content: "I’ve been considering pivot doors for a while—definitely more modern and sleek than the usual styles."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Maintenance Guide",
    date: "03 March, 2025",
    admin: "Admin",
    heading: "Window Maintenance Made Easy: Your Complete Guide",
    important: {
      content: "Maintaining your windows is essential for preserving the aesthetics and efficiency of your home. In this guide, we provide simple steps to keep your windows in top condition, saving you time and money.",
      intro: "Home Maintenance Expert"
    },
    paragraph: {
      para1: "Windows are one of the most important features of any home, providing natural light, ventilation, and insulation. Proper maintenance can extend their lifespan, improve energy efficiency, and enhance your home's overall comfort.",
      para2: "1. **Regular Cleaning** – Keeping your windows clean is one of the simplest and most effective maintenance tasks. Use a mild cleaning solution and a microfiber cloth to avoid scratches and remove dust, dirt, and grime.",
      para3: "2. **Check for Leaks** – Inspect the seals around your windows to prevent air leaks that can affect your home’s energy efficiency. Replace damaged weather stripping and caulk gaps to ensure your windows are properly sealed.",
      para4: "3. **Lubricate Moving Parts** – For windows with sliding or hinged mechanisms, lubricate the tracks and hardware regularly to ensure smooth operation and avoid wear and tear.",
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Windows", "Maintenance", "Comfort"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "John Davis",
        date: "4 May, 2025",
        content: "This guide is so helpful! I didn’t realize how much regular cleaning and sealing could improve window efficiency.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Sophie Turner",
            date: "5 May, 2025",
            content: "I’ve noticed a huge difference since I started sealing around my windows—thanks for the tip!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Ethan Wright",
        date: "5 May, 2025",
        content: "I’ve been meaning to lubricate the moving parts of my windows. Thanks for the reminder!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Energy Efficiency",
    date: "29 February, 2025",
    admin: "Admin",
    heading: "The Role of Solar Panels in Shaping Window Design",
    important: {
      content: "Solar panels are changing the way we design and install windows. This post explores how integrating solar energy solutions impacts window placement, material selection, and overall building performance.",
      intro: "Sustainable Architecture Specialist"
    },
    paragraph: {
      para1: "As the demand for renewable energy increases, architects and builders are exploring new ways to integrate solar panels into residential and commercial buildings. One such innovation is designing windows that complement solar power systems, enhancing both energy efficiency and aesthetics.",
      para2: "Solar panels can affect window placement, size, and even the materials used in window construction. For instance, windows facing south may need to be strategically placed or shaded to optimize the performance of rooftop solar panels.",
      para3: "Materials such as high-performance glazing can help reduce heat gain from the sun while still allowing ample natural light to enter the home. This makes the home more energy-efficient and comfortable year-round.",
      para4: "Innovative solutions, like photovoltaic glass and smart windows, are becoming more common. These windows allow homeowners to generate solar energy directly from their windows without sacrificing style or functionality.",
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Solar", "Windows", "Design"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Olivia Harper",
        date: "11 May, 2025",
        content: "This is such an interesting take on how solar panels are affecting window design. I hadn’t considered how they could influence window placement before.",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "James Walker",
            date: "12 May, 2025",
            content: "Yes, it’s fascinating how much design and technology are intersecting to create more sustainable homes!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Liam Stevens",
        date: "12 May, 2025",
        content: "The idea of photovoltaic glass sounds amazing! Can’t wait to see how this technology evolves."
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Security Solutions",
    date: "21 February, 2025",
    admin: "Admin",
    heading: "Boosting Home Security with Advanced Door Lock Technology",
    important: {
      content: "As home security technology evolves, advanced door locks are becoming a key feature in protecting homes. This post explores the latest door lock technologies that enhance security and convenience for homeowners.",
      intro: "Home Security Expert"
    },
    paragraph: {
      para1: "The security of your home starts with the front door, and with the advent of advanced door lock technology, protecting your home has never been easier. From smart locks to biometric systems, modern door locks offer enhanced security features that traditional locks can’t match.",
      para2: "1. **Smart Locks** – These locks allow you to control access to your home remotely through an app on your phone. You can lock and unlock your door from anywhere, set temporary access codes for guests, and receive alerts whenever someone enters or exits your home.",
      para3: "2. **Biometric Locks** – With biometric locks, security goes beyond passwords and keys. These locks use fingerprint or retina scans to grant access, ensuring only authorized individuals can enter your home.",
      para4: "3. **Bluetooth and Wi-Fi-Enabled Locks** – Bluetooth and Wi-Fi-enabled door locks allow homeowners to unlock doors without physical keys. With integration into home automation systems, you can unlock your door using voice commands or schedule automatic locking and unlocking.",
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Security", "Door", "Technology"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Ava Mitchell",
        date: "16 May, 2025",
        content: "I’m considering upgrading to a smart lock. The ability to control it from my phone sounds so convenient!",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Ethan Black",
            date: "17 May, 2025",
            content: "Smart locks are definitely worth it. I love being able to check if I locked my door remotely."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Sophia Carter",
        date: "17 May, 2025",
        content: "Biometric locks are the future! I’ve been eyeing a fingerprint door lock for my house."
      }
    ]
  },
  {
    id: 11,
    image: images.blog11,
    category: "Customer Stories",
    date: "12 February, 2025",
    admin: "Admin",
    heading: "Enhancing Home Comfort and Style with Our Products",
    important: {
      content: "Our carefully curated products are designed to elevate your home, blending comfort with style. In this post, we explore how our offerings can transform your living spaces into functional, beautiful areas.",
      intro: "Home Design Expert"
    },
    paragraph: {
      para1: "Creating a comfortable and stylish home requires the right balance of design, functionality, and quality products. Whether you're looking to update your windows, doors, or security systems, the right choices can make a world of difference.",
      para2: "1. **Energy-Efficient Windows** – Our energy-efficient windows are designed to keep your home comfortable year-round. By reducing heat loss in the winter and keeping your home cool in the summer, they help maintain the perfect indoor temperature while lowering energy bills.",
      para3: "2. **Stylish Doors** – The right door can set the tone for your entire home. From sleek, modern designs to classic styles, our doors provide both style and security. With enhanced features like multi-point locking systems and weather-resistant finishes, you can trust our doors to offer both beauty and protection.",
      para4: "3. **Smart Home Integration** – Enhance your home’s functionality with smart home products like automated door locks, lighting systems, and security cameras. These modern products not only add convenience but also increase your home’s overall security and efficiency.",
    },
    gallery: [
      images.blog11Gallery1,
      images.blog11Gallery2
    ],
    tags: ["Comfort", "Style", "Products"],
    comments: [
      {
        id: 1,
        image: images.blog11Comment1,
        name: "Mia Williams",
        date: "21 May, 2025",
        content: "I love the energy-efficient windows! My home feels so much cooler in the summer, and my utility bills are lower.",
        replies: [
          {
            id: 1,
            image: images.blog11Comment2,
            name: "Liam Brown",
            date: "22 May, 2025",
            content: "Same here! I’ve noticed a big difference in my energy costs since I switched to these windows."
          }
        ]
      },
      {
        id: 2,
        image: images.blog11Comment3,
        name: "Olivia Green",
        date: "22 May, 2025",
        content: "The smart door locks are such a great addition. I can’t imagine going back to traditional locks now!"
      }
    ]
  },
  {
    id: 12,
    image: images.blog12,
    category: "Design Tips",
    date: "2 February, 2025",
    admin: "Admin",
    heading: "Selecting the Ideal Door Style for Your Home",
    important: {
      content: "Choosing the right door style is essential to both the aesthetics and functionality of your home. In this post, we guide you through selecting the ideal door style that matches your needs and enhances your home’s curb appeal.",
      intro: "Home Design Specialist"
    },
    paragraph: {
      para1: "The right door can make a huge difference in the overall look and feel of your home. It’s one of the first things people notice when approaching your house, so it’s important to choose a style that complements both your home’s architecture and your personal style.",
      para2: "1. **Classic Wooden Doors** – For those who love timeless elegance, wooden doors offer a warm and natural aesthetic. Available in a variety of finishes and designs, they are perfect for traditional or rustic-style homes, providing both beauty and durability.",
      para3: "2. **Modern Glass Doors** – If you’re aiming for a sleek, contemporary look, glass doors are the way to go. They allow natural light to flow into your home, creating a bright and welcoming atmosphere. Plus, they can provide an open feel while maintaining privacy with frosted or tinted glass options.",
      para4: "3. **Custom Steel Doors** – Steel doors are known for their security and strength, making them an excellent choice for homeowners looking for added protection. They come in a variety of styles, from minimalist to bold designs, offering both modern appeal and peace of mind.",
    },
    gallery: [
      images.blog12Gallery1,
      images.blog12Gallery2
    ],
    tags: ["Door", "Style", "Design"],
    comments: [
      {
        id: 1,
        image: images.blog12Comment1,
        name: "Emma Clarke",
        date: "26 May, 2025",
        content: "I’ve been thinking about upgrading my front door, and this post helped me decide between wood and steel options. Thanks for the guidance!",
        replies: [
          {
            id: 1,
            image: images.blog12Comment2,
            name: "Noah Lee",
            date: "27 May, 2025",
            content: "Wooden doors are a classic choice, but steel doors provide extra security. It really depends on what you need most."
          }
        ]
      },
      {
        id: 2,
        image: images.blog12Comment3,
        name: "Isabella Turner",
        date: "27 May, 2025",
        content: "French doors would look amazing in my living room, but I love the idea of sliding doors for my patio. Decisions, decisions!"
      }
    ]
  }

];

export default blogs;